import { render } from "./AutomationTemplatesSellsy.vue?vue&type=template&id=3b10c71f&scoped=true"
import script from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js"
export * from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js"

import "./AutomationTemplatesSellsy.vue?vue&type=style&index=0&id=3b10c71f&lang=scss&scoped=true"
import "./AutomationTemplatesSellsy.vue?vue&type=style&index=1&id=3b10c71f&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b10c71f"]])

export default __exports__